import React from 'react';
import {Button, Dropdown, Input} from 'semantic-ui-react';
import '../styles.scss';

const TablePaginator = ({
  page,
  canPreviousPage,
  pageIndex,
  pageOptions,
  pageSize,
  canNextPage,
  nextPage,
  gotoPage,
  previousPage,
  setPageSize,
  pagesSizeList,
}) => {
  if (page.length) {
    return (
      <div className='commercial-paginator-container'>
        <Button
          className="navigation-button"
          onClick={() => previousPage()}
          disabled={!canPreviousPage}
          content="Anterior"
        />
        <div>
          <span>páginas </span>
          <span>
            <Input
              className="pages-input"
              type="number"
              value={pageIndex + 1}
              min="1"
              max={pageOptions.length}
              onChange={(e, {value}) => {
                const page = value ? Number(value) - 1 : 0;
                if (page < 1 || page > pageOptions.length) {
                  e.target.value = 1;
                }
                gotoPage(page);
              }}
            />
          </span>{' '}
          <span className='mr'>de {pageOptions.length}</span>
          <Dropdown
            upward
            className="page-sizes-selection"
            selection
            compact
            value={pageSize}
            options={pagesSizeList}
            onChange={(e, {value}) => {
              setPageSize(Number(value));
            }}
          />
          <span> filas</span>
        </div>
        <Button
          className="navigation-button"
          onClick={() => nextPage()}
          disabled={!canNextPage}
          content="Siguiente"
        />
      </div>
    );
  }
  return null;
};

export default TablePaginator;
